import { MessageRole } from '@openx/components-core/lib/AiChat/types.ts';
import type { Components } from 'react-markdown';
import type { TroubleshootingMessage } from '../components/FeedbackMessageActions/FeedbackMessageActions.tsx';
import { htmlToPlainText } from './htmlToPlainText.ts';
import { markdownToHtml } from './markdownToHtml.tsx';

export const getTroubleshootingClipboardContent = async (
  message: TroubleshootingMessage,
  components: Components = {}
) => {
  if (message.role === MessageRole.EVENT || message.role === MessageRole.WIDGET) {
    return { plainText: '', htmlText: '' };
  }

  const markdown = [message.summary?.trim(), message.text.trim()].filter(Boolean).join('\n\n');
  const htmlText = await markdownToHtml(markdown, components);

  return {
    plainText: htmlToPlainText(htmlText),
    htmlText,
  };
};
